var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-button-group",
    { attrs: { size: _vm.size } },
    [
      _c(
        "b-button",
        {
          attrs: { variant: _vm.variant },
          on: {
            click: function($event) {
              return _vm.$emit("selected", _vm.id)
            }
          }
        },
        [_vm.$slots.default ? _vm._t("default") : [_vm._v(_vm._s(_vm.text))]],
        2
      ),
      _vm._v(" "),
      _vm.removable
        ? _c(
            "b-button",
            {
              staticClass: "btn-remove",
              attrs: { size: "sm", variant: _vm.variant },
              on: {
                click: function($event) {
                  return _vm.$emit("removed", _vm.id)
                }
              }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }